export function forEachAsync(arr, cb) {
  return arr.reduce((acc, value, index) => acc.then(() => cb(value, index, arr)), Promise.resolve());
}

export function mapAsync(arr, cb) {
  return arr.reduce(async (acc, value, index) => [...(await acc), await cb(value, index, arr)], []);
}

async function next(cbFn) {
  if (!this.length) {
    return;
  }

  const { value, index } = this.shift();

  await cbFn(value, index);
  await next.call(this, cbFn);
}

export function concurrentForEachAsync(arr, cb, { concurrency = 10 } = {}) {
  const queue = arr.map((value, index) => ({ index, value }));

  return Promise.all(
    Array(concurrency)
      .fill()
      .map(() => next.call(queue, cb)),
  );
}
